import classNames from 'classnames'
import { useState, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Swiper as SwiperType } from 'swiper'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'

import styles from './Review.module.scss'

import { useVersion } from 'hooks'
import { feedbackData, statisticsData } from 'resources'
import { FeedbackCard, SectionLayout, StatisticsCard } from 'components'
import { ReactComponent as ArrowIcon } from 'assets/svg/arrow.svg'

const youtubePreview2024 = 'https://www.youtube.com/embed/dW2fbKD1x_A?si=qHXVf2CFW7cPfA3i'

// const youtubePreview2025 = 'https://www.youtube.com/embed/FNEBGGo6-5k?si=vnWDuDt_VzccDQmZ'

// interface ReviewProps {
//   isEdition?: boolean
// }

const Review = () => {
  const swiperRef = useRef()
  const { version } = useVersion()

  const [currentIndex, setCurrentIndex] = useState<number>(0)

  const activeEventFeedbackData = feedbackData[version as keyof typeof feedbackData]
  const activeEventStatisticsData = statisticsData[version as keyof typeof feedbackData]

  const renderStatisticsList = activeEventStatisticsData.map(statistics => (
    <StatisticsCard key={statistics.id} data={statistics} />
  ))

  const renderFeedbackList = activeEventFeedbackData.map(feedback => (
    <SwiperSlide key={feedback.id}>
      <FeedbackCard data={feedback} />
    </SwiperSlide>
  ))

  const updateIndex = (swiperInstance: SwiperType) => {
    if (swiperInstance === null) return
    const currentSlide = swiperInstance?.activeIndex
    setCurrentIndex(currentSlide)
  }

  const pagination = {
    clickable: true,
    renderBullet: function (_: number, className: string) {
      return `<span class="${className}"> </span>`
    },
  }

  return (
    <SectionLayout id='ABOUT-COMMUNITY-DAY' className={styles.wrapper}>
      <div className='container'>
        <h2 className={styles.title}>AWS Community Day Armenia {version}</h2>

        <div className={styles.statistics}>{renderStatisticsList}</div>

        <div className={classNames('statisticSlider', { [styles.feedback]: version === 2024 })}>
          <h2 className={styles.title}>What You Shared</h2>
          <Swiper
            loop
            initialSlide={0}
            onRealIndexChange={updateIndex}
            onBeforeInit={(swiper: any) => {
              swiperRef.current = swiper as any
            }}
            pagination={pagination}
            modules={[Autoplay, Pagination, Navigation]}
            spaceBetween={28}
            slidesPerView={1}
          >
            {renderFeedbackList}

            <button
              disabled={!currentIndex}
              className='swaper--prev'
              onClick={() => {
                if (currentIndex < 3) {
                  ;(swiperRef.current as any)?.slideTo(0)
                } else {
                  ;(swiperRef.current as any)?.slideTo(currentIndex - 1)
                }
              }}
            >
              <ArrowIcon />
            </button>
            <button
              disabled={currentIndex === activeEventFeedbackData.length - 1}
              className='swaper--next'
              onClick={() => (swiperRef.current as any)?.slideTo(currentIndex + 1)}
            >
              <ArrowIcon />
            </button>
          </Swiper>
        </div>

        {version === 2024 && (
          <div className={styles.video}>
            <h2 className={styles.video__title}>Our Official Recap Film</h2>
            <iframe
              src={youtubePreview2024}
              title='YouTube video player'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            />
          </div>
        )}
      </div>
    </SectionLayout>
  )
}

export default Review
